<template>
    <section
        aria-label="Farol do seller"
        class="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700"
    >
        <div
            role="tablist"
            aria-label="Seções do retrato"
            class="grid grid-cols-1 gap-px bg-gray-200 dark:bg-gray-700 sm:grid-cols-3"
        >
            <template v-if="loading">
                <div
                    v-for="n in 3"
                    :key="n"
                    class="space-y-2 bg-white px-4 py-3 dark:bg-gray-800"
                >
                    <div
                        class="h-2 w-16 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-4 w-40 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                    <div
                        class="h-2 w-32 rounded-sm bg-gray-100 dark:bg-gray-700"
                    ></div>
                </div>
            </template>

            <article
                v-else
                v-for="signal in signals"
                :key="signal.key"
                role="tab"
                tabindex="0"
                :aria-selected="active === signal.key"
                :aria-label="`${signal.question} ${statusLabel(signal.status)}. Mostrar seção ${signal.domain}`"
                class="group relative cursor-pointer bg-white px-4 py-3 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-500 dark:bg-gray-800 dark:hover:bg-gray-700/60"
                :class="wash(signal.status)"
                @click="$emit('go', signal.key)"
                @keydown.enter.prevent="$emit('go', signal.key)"
                @keydown.space.prevent="$emit('go', signal.key)"
            >
                <!-- Seleção sem borda: o eyebrow da aba ativa acende em
                     indigo e o texto das inativas fica mais apagado. -->
                <div class="flex items-center justify-between gap-2">
                    <p
                        class="font-mono text-[10px] uppercase tracking-[0.16em]"
                        :class="
                            active === signal.key
                                ? 'font-semibold text-indigo-500 dark:text-indigo-400'
                                : 'text-gray-400 dark:text-gray-500'
                        "
                    >
                        {{ signal.domain }}
                    </p>
                    <span
                        class="shrink-0 rounded-full px-2 py-0.5 font-mono text-[9px] uppercase tracking-widest"
                        :class="chip(signal.status)"
                    >
                        {{ statusLabel(signal.status) }}
                    </span>
                </div>

                <h3
                    class="mt-1 text-sm font-semibold"
                    :class="
                        active === signal.key
                            ? 'text-gray-900 dark:text-white'
                            : 'text-gray-600 dark:text-gray-400'
                    "
                >
                    {{ signal.question }}
                </h3>

                <p
                    class="mt-1 line-clamp-2 text-[11px] leading-relaxed"
                    :class="
                        active === signal.key
                            ? 'text-gray-600 dark:text-gray-300'
                            : 'text-gray-400 dark:text-gray-500'
                    "
                    :title="signal.reason"
                >
                    <highlighted-text :text="signal.reason" />
                </p>
            </article>
        </div>
    </section>
</template>

<script>
import HighlightedText from "../../../views/monitoring/HighlightedText.vue";

export default {
    name: "SellerFarol",
    components: { HighlightedText },
    props: {
        // [{ key, domain, question, status: ok|attention|critical, reason }]
        signals: { type: Array, required: true },
        loading: { type: Boolean, default: false },
        // Chave da seção/aba selecionada (caixa | operacao | conduta)
        active: { type: String, default: null },
    },

    emits: ["go"],

    methods: {
        statusLabel(status) {
            return (
                {
                    ok: "ok",
                    attention: "atenção",
                    critical: "alerta",
                }[status] ?? "ok"
            );
        },

        chip(status) {
            return (
                {
                    attention:
                        "bg-amber-500/10 text-amber-600 dark:bg-amber-500/15 dark:text-amber-300",
                    critical:
                        "bg-rose-500/10 text-rose-600 dark:bg-rose-500/15 dark:text-rose-300",
                }[status] ??
                "bg-emerald-500/10 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-300"
            );
        },

        wash(status) {
            return (
                {
                    attention: "bg-amber-50/70! dark:bg-amber-500/4!",
                    critical: "bg-rose-50/70! dark:bg-rose-500/5!",
                }[status] ?? ""
            );
        },
    },
};
</script>
